export default __webpack_public_path__ + "static/media/external-link.e82eadf0.svg";